import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, from } from 'rxjs';

import { OAuth2Service } from './oauth.service';
import { getHttpHeaders } from '../constants/constants';
import { resourceServerUrl } from '../constants/server-settings';

@Injectable()
export class SessionService {
    redirectUrl: string;
    logoutMessage: string;
    hasSessionExpired: boolean = false;

    constructor(
        private _router: Router,
        private _oAuth2Service: OAuth2Service,
        private _http: HttpClient
    ) {}

    renewToken$(): Observable<any> {
        return from(this._oAuth2Service.oAuth2.exchangeRefreshTokenForAccessToken());
    }

    revokeToken$(): Observable<HttpResponse<any>> {
        return this._http.put(`${resourceServerUrl}/v1/user/logout`, {}, { headers: getHttpHeaders(), observe: 'response' });
    }

    logout(): void {
        this.revokeToken$().subscribe({
            next: response => {
                if (response.status === 200) {
                    this.logoutV2();
                }
            },
            error: () => {
                this._oAuth2Service.oAuth2.reset();
                localStorage.clear();
                this.logoutNavigate();
            }
        });
    }

    logoutV2(): void {
        this._oAuth2Service.oAuth2.reset();
        localStorage.clear();
        this.logoutNavigate();
    }

    logoutNavigate(): void {
        if (this.hasSessionExpired) {
            this._router.navigate(['/session-expired']);
        } else {
            this._router.navigate(['/login']).then(isNavigated => {
                if (isNavigated) {
                }
            });
        }
    }
}
